<script>
  import { appSession, appConstants } from "../stores/app.js";

  // resolve individual pilot
  export function GetPilots(pilotId, queryString = "") {
    return new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      let url = $appConstants.apiURLBase + "pilots/" + pilotId;
      if (queryString != "") url += "?" + queryString;
      xhr.open("GET", url);

      xhr.setRequestHeader(
        "Authorization",
        "Bearer " + $appSession.authorisationToken
      );
      xhr.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
      xhr.send(null);
      xhr.onload = () => {
        try {
          if (xhr.status < 200 || xhr.status >= 300) throw "NetworkError";
          let response = JSON.parse(xhr.response);
          if (response.success != true) throw response.errormessage;
          resolve(response.data);
        } catch (e) {
          reject(e);
        }
      };
      xhr.onerror = () => {
        reject("NetworkError");
      };
    });
  }

  // resolve list of pilots
  export function GetPilotsList(queryString = "") {
    return new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      let url = $appConstants.apiURLBase + "pilots";
      if (queryString != "") url += "?" + queryString;
      xhr.open("GET", url);
      xhr.setRequestHeader(
        "Authorization",
        "Bearer " + $appSession.authorisationToken
      );
      xhr.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
      xhr.send(null);
      xhr.onload = () => {
        try {
          if (xhr.status < 200 || xhr.status >= 300) throw "NetworkError";
          let response = JSON.parse(xhr.response);
          if (response.success != true) throw response.errormessage;
          resolve(response.data);
        } catch (e) {
          reject(e);
        }
      };
      xhr.onerror = () => {
        reject("NetworkError");
      };      
    });
  }

  // put an existing pilot
  export function PutPilots(pilotId, fields) {
    return new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      xhr.open("PUT", $appConstants.apiURLBase + "pilots/" + pilotId);
      xhr.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
      xhr.setRequestHeader(
        "Authorization",
        "Bearer " + $appSession.authorisationToken
      );
      xhr.send(JSON.stringify({ fields: fields }));
      xhr.onload = () => {
        try {
          if (xhr.status < 200 || xhr.status >= 300) throw "NetworkError";
          let response = JSON.parse(xhr.response);
          if (response.success != true) throw response.errormessage;
          resolve();
        } catch (error) {
          reject(error);
        }
      };
      xhr.onerror = () => {
        reject("NetworkError");
      };
    });
  }

  // post a new pilot
  export function PostPilots(fields) {
    return new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      xhr.open("POST", $appConstants.apiURLBase + "pilots");
      xhr.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
      xhr.setRequestHeader(
        "Authorization",
        "Bearer " + $appSession.authorisationToken
      );
      xhr.send(JSON.stringify({ fields: fields }));
      xhr.onload = () => {
        try {
          if (xhr.status < 200 || xhr.status >= 300) throw "NetworkError";
          let response = JSON.parse(xhr.response);
          if (response.success != true) throw response.errormessage;
          resolve(response.pilotid);
        } catch (error) {
          reject(error);
        }
      };
      xhr.onerror = () => {
        reject("NetworkError");
      };
    });
  }

// delete an existing pilot
  export function DeletePilots(pilotId) {
    return new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      xhr.open("DELETE", $appConstants.apiURLBase + "pilots/" + pilotId);
      xhr.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
      xhr.setRequestHeader(
        "Authorization",
        "Bearer " + $appSession.authorisationToken
      );
      xhr.send();
      xhr.onload = () => {
        try {
          if (xhr.status < 200 || xhr.status >= 300) throw "NetworkError";
          let response = JSON.parse(xhr.response);
          if (response.success != true) throw response.errormessage;
          resolve();
        } catch (error) {
          reject(error);
        }
      };
      xhr.onerror = () => {
        reject("NetworkError");
      };
    });
  }

</script>
